import React from 'react';
import { PropInfo, CodeExample, CheckboxProps } from '@cimpress/react-components';
import CheckboxCode from '!raw-loader!./checkbox.jsx';
import CheckboxDemo from './checkbox.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const CheckboxDocs = () => {
  const propInfos: PropInfo<CheckboxProps>[] = [
    {
      name: 'label',
      type: 'string or node',
      default: '',
      description: 'Label for the checkbox.',
    },
    {
      name: 'id',
      type: 'string',
      default: '',
      description: 'ID prop for the input field',
    },
    {
      name: 'whiteBackground',
      type: 'boolean',
      default: 'false',
      description: 'If set to true, the checkbox icon is rendered with white background, otherwise - transparent.',
    },
    {
      name: 'checked',
      type: 'boolean',
      default: '',
      description: 'Determines whether or not the checkbox is checked',
    },
    {
      name: 'indeterminate',
      type: 'boolean',
      default: '',
      description: (
        <div>
          Determines whether or not the checkbox is in an indeterminate state. If <code>checked</code> is true, it will
          override <code>indeterminate</code>.
        </div>
      ),
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: 'false',
      description: 'Marks the checkbox as disabled',
    },
    {
      name: 'className',
      type: 'string',
      default: '',
      description: 'Additional classNames to be appended to the parent element of the input field',
    },
    {
      name: 'onChange',
      type: 'function',
      default: '',
      description: (
        <div>
          <p>Callback function that is fired when the checked value changes. </p>
          <p>
            Signature: <code>function(event: object, payload: any) {'=>'} void</code>{' '}
          </p>
          <p>
            <code>event:</code> Change event targeting the checkbox.
            <code>payload:</code> The payload prop value.
          </p>
        </div>
      ),
    },
    {
      name: 'payload',
      type: 'any',
      default: '',
      description: (
        <p>
          Anything you want passed in to the <code>onChange</code> handler as the second argument.
        </p>
      ),
    },
    {
      name: 'inline',
      type: 'boolean',
      default: 'false',
      description: <p>If set to true, checkbox will display in a row instead of being stacked</p>,
    },
  ];
  return (
    <ComponentDoc<CheckboxProps> name="Checkbox" propInfos={propInfos}>
      <CheckboxDemo />
      <CodeExample code={CheckboxCode} />
    </ComponentDoc>
  );
};

export default CheckboxDocs;
